import React from 'react';
import { useTranslations } from '@unisporkal/localization';
import styles from './AcquisitionTitle.module.scss';
import CloseIcon from '../../icons/Close.svg?icon';
import acquisitionTypes from '../../support/acquisitionTypes';

interface AcquisitionType {
  title: string;
  type: string;
}

interface TitleWithCloseIconProps {
  closeCurrentAcquisitionView?: () => void;
  availableAcquisitionTypes?: AcquisitionType[];
  acquisitionType?: string;
  downloadAcquisitionTitle?: string;
}

const TitleWithCloseIcon = ({
  closeCurrentAcquisitionView = () => {},
  availableAcquisitionTypes = [],
  acquisitionType = '',
  downloadAcquisitionTitle = '',
}: TitleWithCloseIconProps) => {
  const t = useTranslations();
  const currentType = availableAcquisitionTypes.find(
    (acqType) => acqType.type === acquisitionType
  );
  const customDownloadTitle =
    currentType?.type ===
    (acquisitionTypes.DOWNLOAD ||
      acquisitionTypes.PREVIEW ||
      acquisitionTypes.MODIFIED_DOWNLOAD);

  const acquisitionTitle = customDownloadTitle
    ? downloadAcquisitionTitle
    : currentType?.title;

  return (
    <div
      className={styles.viewStack}
      data-testid="title-with-close-icon"
    >
      <div className={styles.viewStackTitle}>
        {acquisitionTitle ? t(acquisitionTitle) : null}
      </div>
      <button
        className={styles.close}
        type="button"
        aria-label="Close"
        onClick={closeCurrentAcquisitionView}
        data-testid="close-icon"
      >
        <CloseIcon />
      </button>
    </div>
  );
};

export default TitleWithCloseIcon;
